import { render, staticRenderFns } from "./vue-resizable.vue?vue&type=template&id=05b53eb8&scoped=true&"
import script from "./vue-resizable.vue?vue&type=script&lang=js&"
export * from "./vue-resizable.vue?vue&type=script&lang=js&"
import style0 from "./vue-resizable.vue?vue&type=style&index=0&id=05b53eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b53eb8",
  null
  
)

export default component.exports